import CurrencyDispatcher from '~/flux/dispatchers/CurrencyDispatcher';
import { GraphQlRequestError } from '~/graphql/graphqlClient';
import mutationNewsletterSignup from '~/graphql/player/mutationNewsletterSignup';

type SocialState = Record<string, unknown> & {
  signed_up_newsletter?: boolean | null;
  newsletter_email?: string | null;
};

type NewsletterSignupEvent = 'NEWSLETTER_SIGNUP_ERROR' | 'NEWSLETTER_SIGNUP_SUCCESS';

export default async function newsletterSignup(
  {
    playerId,
    setSocial,
    emit,
  }: {
    playerId: string | null | false;
    setSocial: (updater: (prev: SocialState) => SocialState) => void;
    emit: (event: NewsletterSignupEvent, payload?: string) => void;
  },
  action: { email: string }
) {
  if (!playerId) {
    emit('NEWSLETTER_SIGNUP_ERROR', 'Not logged in.');
    return;
  }

  try {
    const result = await mutationNewsletterSignup({
      playerId: String(playerId),
      email: action.email,
    });

    if (!result.ok) {
      emit('NEWSLETTER_SIGNUP_ERROR', result.detail || 'An error occurred');
      return;
    }

    setSocial((prev) => ({
      ...(prev || {}),
      signed_up_newsletter: true,
      newsletter_email: action.email,
    }));

    if (typeof result.currency1 === 'number') {
      CurrencyDispatcher.handleCurrencyAction({
        actionType: CurrencyDispatcher.NEW_CURRENCY_BALANCE,
        currency1: result.currency1,
      });
    }

    emit('NEWSLETTER_SIGNUP_SUCCESS');
  } catch (err) {
    const detail = err instanceof GraphQlRequestError ? err.errors?.[0]?.message : undefined;
    emit('NEWSLETTER_SIGNUP_ERROR', detail || 'Server error.');
  }
}
